export default "__VITE_ASSET__h_5h4zcX__"